import { render, staticRenderFns } from "./DownloadPlans.vue?vue&type=template&id=3bc70c67&scoped=true&"
import script from "./DownloadPlans.vue?vue&type=script&lang=js&"
export * from "./DownloadPlans.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPlans.vue?vue&type=style&index=0&id=3bc70c67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc70c67",
  null
  
)

/* custom blocks */
import block0 from "./DownloadPlans.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports